module.exports = __webpack_public_path__ + "img/valutami.b784915f.png";